/** Number formatting for readouts (PLAN.md §10: every readout has units). */

/** 75.5 → "1:15.500" */
export function formatTime(seconds: number): string {
  const sign = seconds < 0 ? '−' : '';
  const s = Math.abs(seconds);
  const m = Math.floor(s / 60);
  const rest = s - m * 60;
  return `${sign}${m}:${rest.toFixed(3).padStart(6, '0')}`;
}

export function formatHz(f: number): string {
  return f >= 1000 ? `${+(f / 1000).toFixed(3)} kHz` : `${+f.toFixed(1)} Hz`;
}

export function formatDb(db: number, unit = 'dBFS'): string {
  if (!Number.isFinite(db) || db <= -300) return `−∞ ${unit}`;
  return `${db < 0 ? '−' : ''}${Math.abs(db).toFixed(1)} ${unit}`;
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 ** 2) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 ** 2).toFixed(1)} MB`;
}

export function formatInt(n: number): string {
  return n.toLocaleString('en-US').replace(/,/g, ' ');
}
